import React from 'react';
import { Grid, MenuItem, Select } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import WSForm from "../../../../../websocketService/WSForm";

class HousingResourceQuality extends React.Component {
    constructor(props) {
        super(props);
        this.data = this.props.data;
    }
    componentDidUpdate() {
        this.data = this.props.data;
    }
    options0to100 = () => {
        let rows = [];
        for (let i = 0; i < 100; i++) {
            rows.push(i);
        }
        return rows;
    }
    updateInput = (event) => {
        this.data[event.target.name] = event.target.value;
        this.props.updateQuality(this.props.id, this.data);
    }
    render() {


        return (
            <Grid container>
                <Grid item sm={12}>
                    <label className="form-label" style={{ fontWeight: "bold" }}>{this.props.label}</label>
                </Grid>
                <Grid item sm={12}>
                    <Grid container>
                        <Grid item sm={6}>
                            <label className="form-label">Úroveň kvality</label>
                        </Grid>
                        <Grid item sm={6}>
                            <Select
                                labelId="demo-simple-select-label"
                                name="quality"
                                value={this.props.data.quality}
                                onChange={this.updateInput}
                            >
                                <MenuItem value={1}>premium</MenuItem>
                                <MenuItem value={0.7}>standard</MenuItem>
                            </Select>
                        </Grid>
                    </Grid>

                </Grid>
                <Grid item sm={12}>
                    <Grid container>
                        <Grid item sm={6}>
                            <label className="form-label">Náklady</label>
                        </Grid>
                        <Grid item sm={6} key={this.props.data}>
                            <TextField
                                id="standard-basic"
                                name="costs"
                                value={this.props.data.costs}
                                disabled={true}
                                onChange={this.updateInput}
                            />
                        </Grid>
                    </Grid>

                </Grid>
            </Grid>
        );
    }
}
export default HousingResourceQuality;
